module.exports = __webpack_public_path__ + "img/unibud24070.7e169804.png";